// extracted by mini-css-extract-plugin
export default {"configuration__wrapper":"Header_configuration__wrapper__IgBuY","configuration__title":"Header_configuration__title__l5Nga","configuration":"Header_configuration__4NYfd"};